<template>
  <ul>
    <li @click="link('/')">
      <img v-if="current!=1" src="../assets/tabbar1.png" alt="">
      <img v-if="current==1" src="../assets/tabbar1-1.png" alt="">
      <p :class="current==1?'on':''">首页</p>
    </li>
    <li @click="link('/order')">
      <img v-if="current!=2" src="../assets/tabbar2.png" alt="">
      <img v-if="current==2" src="../assets/tabbar2-1.png" alt="">
      <p :class="current==2?'on':''">订单</p>
    </li>
    <li @click="link('/msg')">
      <img v-if="current!=3" src="../assets/tabbar3.png" alt="">
      <img v-if="current==3" src="../assets/tabbar3-1.png" alt="">
      <p :class="current==3?'on':''">信息</p>
    </li>
    <li @click="link('/my')">
      <img v-if="current!=4" src="../assets/tabbar4.png" alt="">
      <img v-if="current==4" src="../assets/tabbar4-1.png" alt="">
      <p :class="current==4?'on':''">我的</p>
    </li>
  </ul>
</template>

<script>
    export default {
        name: "Tabbar",
        props: ['current'],
        methods: {
            link(url) {
                this.$router.push(url)
            }
        }
    }
</script>

<style scoped>
  ul {
    width: 100%;
    height: 98px;
    background: #fff;
    border-top: 1px solid #e3e4e6;
    display: flex;
    align-items: center;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 99;
  }

  ul li {
    flex: 1;
  }

  ul li img {
    display: block;
    margin: 0 auto;
    height: 42px;
  }

  ul li p {
    text-align: center;
    font-size: 28px;
    margin-top: 4px;
    color: #575656;
    font-weight: bolder;
  }

  ul li p.on {
    color: #05be8a;
  }
</style>



// WEBPACK FOOTER //
// src/components/Tabbar.vue